import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Sprout, Download } from "lucide-react";
import { toast } from "sonner";

/**
 * Batch C extra (2026-07): org impact-multiplier stat — "Your team contributed
 * X person-hours across Y events" (approved logs only) — plus the Item 6
 * "Export hours (CSV)" download. Hidden until the org has approved hours.
 */
export function OrgImpactStrip() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.orgHourStats().then(setStats).catch(() => setStats(null));
  }, []);

  const exportCsv = async () => {
    try {
      const blob = await api.exportHoursCsv();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `civichearth-approved-hours-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Hours exported");
    } catch {
      toast.error("Could not export hours");
    }
  };

  if (!stats || !stats.logs) return null;
  return (
    <div data-testid="org-impact-multiplier" className="mt-5 flex items-center gap-4 flex-wrap bg-forest text-white rounded-2xl px-6 py-5">
      <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0">
        <Sprout className="w-5 h-5 text-terracotta" />
      </div>
      <div className="flex-1 min-w-[220px]">
        <div className="font-display text-lg leading-snug" data-testid="org-impact-multiplier-text">
          Your team contributed <span className="text-terracotta font-semibold">{stats.person_hours} person-hour{stats.person_hours === 1 ? "" : "s"}</span>
          {stats.events > 0 && <> across <span className="text-terracotta font-semibold">{stats.events} event{stats.events === 1 ? "" : "s"}</span></>}
        </div>
        <div className="text-white/60 text-xs mt-0.5">
          {stats.volunteers} volunteer{stats.volunteers === 1 ? "" : "s"} · approved hours only
        </div>
      </div>
      <Button
        data-testid="export-hours-csv-btn"
        onClick={exportCsv}
        variant="outline"
        className="rounded-full h-9 px-4 text-sm bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white shrink-0"
      >
        <Download className="w-4 h-4 mr-1.5" /> Export hours (CSV)
      </Button>
    </div>
  );
}
